import { ProgressBar } from '@progress/kendo-react-progressbars'
import React, { useMemo } from 'react'

const UsageStatistics = (props) => {
    const { t, title, progressValue, progressLabel, values } = props

    const { ownBusiness, otherBusinesses } = useMemo(() => {
        let ownBusiness = values?.find(x => x.own_business)
        ownBusiness = ownBusiness ? ownBusiness.avg : 0

        let otherBusinesses = values?.find(x => !x.own_business)
        otherBusinesses = otherBusinesses ? otherBusinesses.avg : 0

        return { ownBusiness, otherBusinesses }
    }, [values])

    return (
        <div className='dashboardView-card rasd-usage'>
            <div>
                <p className='dashboardView-card-title'>{title}</p>
                <div className='rasd-usage-vs rasd-usage-vs-values'>
                    <span style={{ flex: 1, textAlign: 'right' }}>{otherBusinesses}</span>
                    <span>vs</span>
                    <span style={{ flex: 1 }}>{ownBusiness}</span>
                </div>
                <div className='rasd-usage-vs rasd-usage-vs-labels'>
                    <span style={{ flex: 1, textAlign: 'right' }}>{t("otherBusinesses")}</span>
                    <span style={{ visibility: 'hidden' }}>vs</span>
                    <span style={{ flex: 1 }}>{t("myBusiness")}</span>
                </div>
            </div>

            <div className='rasd-usage-progress'>
                <p><span>{progressValue.toFixed(0)}%</span> {progressLabel}</p>
                <ProgressBar labelVisible={false} value={progressValue} style={{ height: 16 }} />
            </div>
        </div>
    )
}

export default UsageStatistics